<button class="table-menu-btn" appMenu [placement]="'bottom-right'" [autoClose]="'outside'"
    [menuContent]="tableRowMenuContent" triggers="manual" #tableRowMenu="appMenu"
    (click)="tableRowMenu.toggle();$event.stopPropagation();">
    <img class="menu-icon opened" *ngIf="tableRowMenu.isOpen()" src="assets/icons/icon-close-dark-gray.svg"
        alt="table-row-menu" />
    <img class="menu-icon" *ngIf="!tableRowMenu.isOpen()" src="assets/icons/icon-three-dots.svg" alt="table-row-menu" />
</button>
<ng-template #tableRowMenuContent>
    <div class="menu-container primary">
        <div *ngFor="let item of options"
        (click)="selected.emit(item);tableRowMenu.close();"
            class="menu-item">
            <div class="option icon" 
                [style.--icon-path]="item?.svgPath ? 'url(' + item.svgPath + ')' : ''"
                [style.--active-icon-path]="item?.activeSvgPath ? 'url(' + item.activeSvgPath + ')' : ''"
            >
                {{item.name}}
            </div>
        </div>
    </div>
</ng-template>